import { viewportBandForWidth, type ViewportBand } from '../common/viewportBreakpoints';

export type DeviceSettingsPayload = {
  viewportWidth: number;
  viewportHeight: number;
  screenWidth: number;
  screenHeight: number;
  devicePixelRatio: number;
  viewportBand: ViewportBand;
  colorScheme?: 'light' | 'dark' | 'no-preference';
  timezone?: string;
  language?: string;
  maxTouchPoints?: number;
  prefersReducedMotion?: boolean;
  standalone?: boolean;
};

function readColorScheme(): DeviceSettingsPayload['colorScheme'] | undefined {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return undefined;
  }
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  if (window.matchMedia('(prefers-color-scheme: light)').matches) {
    return 'light';
  }
  return 'no-preference';
}

function readPrefersReducedMotion(): boolean | undefined {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return undefined;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function readStandalone(): boolean | undefined {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return undefined;
  }
  return window.matchMedia('(display-mode: standalone)').matches;
}

export function collectDeviceSettings(): DeviceSettingsPayload {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const devicePixelRatio = window.devicePixelRatio || 1;

  return {
    viewportWidth,
    viewportHeight,
    screenWidth,
    screenHeight,
    devicePixelRatio,
    viewportBand: viewportBandForWidth(viewportWidth),
    colorScheme: readColorScheme(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    maxTouchPoints: navigator.maxTouchPoints,
    prefersReducedMotion: readPrefersReducedMotion(),
    standalone: readStandalone(),
  };
}
